<template>
  <v-form v-model="valid">
    <v-container fluid class="mt-4">
      <v-row dense>
        <v-col cols="12" sm="6" md="5">
          <v-text-field label="Name" v-model="nonExcise.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-text-field label="SKU" v-model="nonExcise.sku" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/>
        </v-col>
        <v-col cols="2" lg="1">
          <v-checkbox label="Active" v-model="nonExcise.active" dense class="mt-1"/>
        </v-col>
      </v-row>

      <v-row v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="nonExcise.inventoryAccountRef" label="Inventory asset account"
                          :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                          hint="The inventory account used to track the value of this non-excise"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'AlcoholNonExcisesEditInfo',
  props: {
    nonExcise: {type:Object, required:true},
    accounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  }
}
</script>